import Api from "./index";
import { endPoints, requestType } from "../constants/Variables";

export const getAllUserByBusiness = (id) => {
  return Api(`${endPoints.getAllUserByBusiness}/${id}`, null, requestType.GET);
};

export const createUser = (params) => {
  return Api(endPoints.createUser, params, requestType.POST);
};

export const updateUser = (id, params) => {
  return Api(`${endPoints.updateUser}/${id}`, params, requestType.PUT);
};

export const deleteTeams = (id) => {
  return Api(`${endPoints.deleteTeams}/${id}`, null, requestType.POST);
};

export const teamSchedule = (id) => {
  return Api(`${endPoints.teamSchedule}/${id}`, null, requestType.GET);
};

// Teams By Services
export const featchAllTeam = (params) => {
  return Api(endPoints.featchAllTeam, params, requestType.POST);
};
export const fetchProTeams = (params) => {
  return Api(endPoints.fetchProTeams, params, requestType.POST);
};
